module.exports = __webpack_public_path__ + "img/B.2d26699b.jpg";